import { useTranslation } from 'react-i18next';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

export const AffiliateHeader = () => {
  const { t } = useTranslation();
  return (
    <TableHead>
      <TableRow>
        <TableCell> </TableCell>
        <TableCell>{t('affiliate.overview.table.id')}</TableCell>
        <TableCell>{t('affiliate.overview.table.name')}</TableCell>
        <TableCell>{t('affiliate.overview.table.email')}</TableCell>
        <TableCell>{t('affiliate.overview.table.address')}</TableCell>
        <TableCell>{t('affiliate.overview.table.birthdate')}</TableCell>
        <TableCell>{t('affiliate.overview.table.link')}</TableCell>
      </TableRow>
    </TableHead>
  );
};
